export default __webpack_public_path__ + "static/evitat-logo-green-a3a6faabab5cb2366fec2512d94019cd.png";